import config from "config/config";
import getTokens from "api/getTokens";

const  { baseUrl, clientUrl } = config;

/* *********************
  email
  password
********************** */

export default function getUser(
  page,
  limit = 50,
  email = "",
  role = "",
  hasMobile = "",
  // we only sort for fields that are encrypted, so sorting is not properly working
  // eslint-disable-next-line
  orderBy = "",
  id = ""
) {
  let order = "sortDisabled";
  // if (orderBy === "email") {
  //   order = "email:asc";
  // } else if (orderBy === "emailReverse") {
  //   order = "email:desc";
  // } else if (orderBy === "role") {
  //   order = "role:asc";
  // } else if (orderBy === "roleReverse") {
  //   order = "role:desc";
  // } else if (orderBy === "createdAt") {
  //   order = "createdAt:asc";
  // } else if (orderBy === "createdAtReverse") {
  //   order = "createdAt:desc";
  // }
  const endpoint = `${baseUrl}/v1/users/?limit=${limit}&page=${page}&sortBy=${order}&populate=clients,clientsManaged&email=${email}&role=${role}&hasMobile=${hasMobile}&id=${id}`;
  let access = "";
  const tokens = getTokens();
  if (tokens && tokens.access && tokens.access.token) {
    access = tokens.access.token;
  } else {
    window.location.href = "/login";
  }
  const options = {
    method: "GET",
    mode: "cors",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": `${clientUrl || ""}`,
      "Access-Control-Allow-Credentials": true,
      Authorization: `bearer ${access}`,
    },
  };
  // console.log('login endpoint', {endpoint, BODY });
  return fetch(endpoint, options)
    .then((response) => {
      // console.log('login response', response);
      if (response.status !== 200 && response.status !== 201 && response.status !== 204) {
        throw new Error();
      }
      return response.json();
    })
    .catch((e) => {
      // eslint-disable-next-line
      console.log("error", e);
    });
}
